import type { ReactNode } from 'react'

import { Link } from 'react-router'

type BlogPost = {
  slug: string
  prefetch?: boolean
}

type Props = {
  blog: BlogPost
  children: ReactNode
  className?: string
}

export default function BlogPostLink({ blog, children, className }: Props) {
  const url = `/blog/${blog.slug}`

  if (blog.prefetch === false) {
    return (
      <a className={className} href={url}>
        {children}
      </a>
    )
  }

  return (
    <Link className={className} prefetch='intent' to={url}>
      {children}
    </Link>
  )
}
